import React, { useEffect } from 'react';
import Score from './score';
import { observer } from 'mobx-react';
import { formatDateAndTime } from '../../utils/helpers';
import pluralize from 'pluralize';
import { useTranslation } from 'react-i18next';
import { Heading1, Heading2, Heading4 } from '@awarego/awarego-components';
import ReviewTableSingleThreat from './AssessmentFinalReview/ReviewTableSingleThreat';
import ReviewTableMultiThreat from './AssessmentFinalReview/ReviewTableMultiThreat';

export default observer(
    ({
        parentUrl,
        assessment,
        companyId,
        assessmentId,
        trainingId,
        assessmentStore,
        preloadedResults,
        shareResults,
    }) => {
        const { loadingAssessmentResults, results, resultsCount } =
            assessmentStore;
        const { t } = useTranslation();

        useEffect(() => {
            if (!preloadedResults)
                assessmentStore.loadResults(companyId, assessmentId);
        }, [preloadedResults, companyId, assessmentId]);

        return (
            <div className="quiz-slide center assessment-review">
                <div className="mobileOnly">
                    <Heading2 bold>{assessment.name}</Heading2>
                    <p>
                        <i className="date-icon done"></i>
                        {resultsCount} {t(pluralize('question', resultsCount))},{' '}
                        {t('completed on')}{' '}
                        {formatDateAndTime(
                            assessment.end || assessment.completed
                        )}
                    </p>
                </div>
                <div className="desktopOnly">
                    <Heading1 bold>{assessment.name}</Heading1>
                    <br />
                    <Heading4 bold>
                        {resultsCount} {t(pluralize('question', resultsCount))},{' '}
                        {t('completed on')} {formatDateAndTime(assessment.end)}.
                    </Heading4>
                </div>
                {assessment && (
                    <Score
                        parentUrl={parentUrl}
                        assessment={assessment}
                        horizontal
                        shareResults={shareResults}
                        shareUrl={assessmentStore.shareUrl()}
                    />
                )}
                <br className="desktopOnly" />
                {results && (
                    <>
                        {Object.keys(results).length > 1 ? (
                            <ReviewTableMultiThreat
                                loadingAssessmentResults={
                                    loadingAssessmentResults
                                }
                                results={results}
                                shareResults={shareResults}
                                parentUrl={parentUrl}
                                trainingId={trainingId}
                                assessmentId={assessment.id}
                                // preOpen={
                                //     Object.keys(results).length === 1
                                //         ? [Object.keys(results)[0]]
                                //         : []
                                // }
                            />
                        ) : (
                            <ReviewTableSingleThreat
                                loadingAssessmentResults={
                                    loadingAssessmentResults
                                }
                                results={results}
                                shareResults={shareResults}
                                parentUrl={parentUrl}
                                trainingId={trainingId}
                                assessmentId={assessment.id}
                            />
                        )}
                    </>
                )}
            </div>
        );
    }
);
